<template>
    <div class="careers-header">
        <app-header-mini v-if="this.$route.params.page === 'application-form'" :img="'/static/img/careers/header.jpg'" :texts="['Кандидатствай онлайн']"></app-header-mini>
        <app-header-mini v-else :img="'/static/img/careers/header.jpg'" :texts="['Кариери']"></app-header-mini>
        <!-- <app-header-mini v-if="this.$route.params.page === 'open-positions'" :img="'/static/img/careers/has/header.jpg'" :texts="texts"></app-header-mini> -->
    </div>
</template>

<script>
import HeaderMini from "../shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/careers/Header.vue